import { render } from "./productItemCart.vue?vue&type=template&id=4a7cf65d&scoped=true"
import script from "./productItemCart.vue?vue&type=script&lang=js"
export * from "./productItemCart.vue?vue&type=script&lang=js"

import "./productItemCart.vue?vue&type=style&index=0&id=4a7cf65d&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a7cf65d"]])

export default __exports__